import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "lista" }
const _hoisted_2 = { class: "field" }
const _hoisted_3 = { class: "control has-icons-left" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "icon is-small is-left" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search" })
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "modal-background" }, null, -1)
const _hoisted_6 = { class: "modal-card" }
const _hoisted_7 = { class: "modal-card-head" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "modal-card-title" }, "Editando uma tarefa", -1)
const _hoisted_9 = { class: "modal-card-body" }
const _hoisted_10 = { class: "field" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  for: "descricaoDaTarefa",
  class: "label"
}, " Descrição ", -1)
const _hoisted_12 = { class: "modal-card-foot" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Formulario = _resolveComponent("Formulario")!
  const _component_Box = _resolveComponent("Box")!
  const _component_Tarefa = _resolveComponent("Tarefa")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Formulario, { onAoSalvarTarefa: _ctx.salvarTarefa }, null, 8, ["onAoSalvarTarefa"]),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.listaEstaVazia)
        ? (_openBlock(), _createBlock(_component_Box, { key: 0 }, {
            default: _withCtx(() => [
              _createTextVNode(" Você ainda não produziu hoje ")
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, [
          _withDirectives(_createElementVNode("input", {
            class: "input",
            type: "text",
            placeholder: "Digite para filtrar",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filtro) = $event))
          }, null, 512), [
            [_vModelText, _ctx.filtro]
          ]),
          _hoisted_4
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tarefas, (tarefa, index) => {
        return (_openBlock(), _createBlock(_component_Tarefa, {
          tarefa: tarefa,
          key: index,
          onAoTarefaClicada: _ctx.selecionarTarefa
        }, null, 8, ["tarefa", "onAoTarefaClicada"]))
      }), 128)),
      (_ctx.tarefaSelecionada)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["modal", { 'is-active': _ctx.tarefaSelecionada }])
          }, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("header", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.fecharModal && _ctx.fecharModal(...args))),
                  class: "delete",
                  "aria-label": "close"
                })
              ]),
              _createElementVNode("section", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "input",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tarefaSelecionada.descricao) = $event)),
                    id: "descricaoDaTarefa"
                  }, null, 512), [
                    [_vModelText, _ctx.tarefaSelecionada.descricao]
                  ])
                ])
              ]),
              _createElementVNode("footer", _hoisted_12, [
                _createElementVNode("button", {
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.alterarTarefa && _ctx.alterarTarefa(...args))),
                  class: "button is-success"
                }, "Salvar alterações"),
                _createElementVNode("button", {
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.fecharModal && _ctx.fecharModal(...args))),
                  class: "button"
                }, "Cancelar")
              ])
            ])
          ], 2))
        : _createCommentVNode("", true)
    ])
  ], 64))
}